export default "__VITE_ASSET__CSqb4Oqf__"